import {createSlice, createAsyncThunk} from '@reduxjs/toolkit';
import ProviderManager from 'app/provider/providerManager';
import {showAppLoader, hideAppLoader} from '../../Shared/Loader/LoaderSlice';
import {isNullOrEmpty} from 'app/utilities/StringHelpers/StringHelpers';
import {errorDescriptionEnum, validateAccountToIMEIService} from 'app/Components/Block/IMEIDeviceRepairBlock/IMEIDeviceRepairSlice';
import {
  BusinessWorkOrderSystemStep,
  MessageContent,
  StayInformedChoiceEnum,
  GenericInputType,
  BusinessWorkOrderSystemPopup,
} from './Constant/Constant';
import {formatDateString14digits} from 'app/utilities/StringHelpers/StringHelpers';

export const fetchExistingRequests = createAsyncThunk('businessWorkOrderSystem/fetchExistingRequests', async (data, thunkAPI) => {
  thunkAPI.dispatch(showAppLoader());
  try {
    const result = await ProviderManager.getProviderData('getBusinessWorkOrderExistingRequests', data);
    return result.Body;
  } catch (error) {
    return error;
  } finally {
    thunkAPI.dispatch(hideAppLoader());
  }
});

export const getWorkOrderData = createAsyncThunk('businessWorkOrderSystem/getWorkOrderData', async (data, thunkAPI) => {
  thunkAPI.dispatch(showAppLoader());
  try {
    var fu_ban = !isNullOrEmpty(data.fu_ban) ? data.fu_ban : '1';
    const result = await ProviderManager.getProviderData('getBusinessWorkOrderInfo', [data.fu_number, fu_ban]);
    thunkAPI.dispatch(hideAppLoader());
    return {fu_number: data.fu_number, ...result.Body};
  } catch (error) {
    thunkAPI.dispatch(hideAppLoader());
    return error;
  }
});

export const getAllBusinessWorkOrderTypes = createAsyncThunk(
  'businessWorkOrderSystem/getAllBusinessWorkOrderTypes',
  async (data, thunkAPI) => {
    thunkAPI.dispatch(showAppLoader());
    try {
      const result = await ProviderManager.getProviderData('getAllBusinessWorkOrderTypes', []);
      return result.Body;
    } catch (error) {
      return error;
    } finally {
      thunkAPI.dispatch(hideAppLoader());
    }
  },
);

export const getWorkOrderForm = createAsyncThunk('businessWorkOrderSystem/getWorkOrderForm', async (data, thunkAPI) => {
  thunkAPI.dispatch(showAppLoader());
  try {
    const result = await ProviderManager.getProviderData('getBusinessWorkOrderForm', [data.fuType, data.orgId]);
    return result.Body;
  } catch (error) {
    return error;
  } finally {
    thunkAPI.dispatch(hideAppLoader());
  }
});

export const validateSelectedAccount = createAsyncThunk('businessWorkOrderSystem/validateSelectedAccount', async (data, thunkAPI) => {
  //thunkAPI.dispatch(showAppLoader());
  try {
    const result = await ProviderManager.getProviderData('validateSelectedAccount', [data.orgId, data.subscriber]);
    return {
      ...result.Body,
      paramCode: data.paramCode,
      isSuccess: result.Body.isAllowed,
      error: SubscriberErrorEnum[result.Body.description],
    };
  } catch (error) {
    return error;
    return error;
  } finally {
    //thunkAPI.dispatch(hideAppLoader());
  }
});

export const isExternalCompanyNumber = createAsyncThunk('businessWorkOrderSystem/IsExternalCompanyNumber', async (data, thunkAPI) => {
  thunkAPI.dispatch(showAppLoader());
  try {
    const result = await ProviderManager.getProviderData('IsExternalCompanyNumber', [data.phoneNumber]);
    thunkAPI.dispatch(hideAppLoader());
    if (result.Body.phoneOperatorName == 'CELL') {
      return {isSuccess: false, error: SubscriberErrorEnum.cellcomNumber};
    }
    return {isSuccess: result.Body?.isSuccess, error: ''};
  } catch (error) {
    thunkAPI.dispatch(hideAppLoader());
    throw error;
  }
});

export const validateSimCardNumber = createAsyncThunk('businessWorkOrderSystem/validateSimCardNumber', async (data, thunkAPI) => {
  try {
    thunkAPI.dispatch(showAppLoader());
    var result = await ProviderManager.getProviderData('ValidateSim', [data]);
    thunkAPI.dispatch(hideAppLoader());
    if (result.Body.statusCode == '00') {
      return {isSuccess: result.Body.boolean, error: result.Body.boolean ? '' : SubscriberErrorEnum.SimCardNotValid};
    }
    return {isSuccess: result.Body?.statusCode == '00' && result.Body.boolean};
  } catch (error) {
    thunkAPI.dispatch(hideAppLoader());
    return {
      serverError: true,
    };
  }
});

export const getExtendedParamData = createAsyncThunk('businessWorkOrderSystem/getExtendedParamData', async (data, thunkAPI) => {
  try {
    var paramCode = data.paramCode;
    var result = await ProviderManager.getProviderData('getExtendedParamData', data);
    return {paramCode: paramCode, result};
  } catch (error) {
    return {
      serverError: true,
    };
  }
});

export const createBusinessWorkOrder = createAsyncThunk('businessWorkOrderSystem/CreateBusinessWorkOrder', async (data, thunkAPI) => {
  thunkAPI.dispatch(showAppLoader());
  try {
    const result = await ProviderManager.getProviderData('CreateBusinessWorkOrder', data);
    return result.Body;
  } catch (error) {
    thunkAPI.dispatch(hideAppLoader());
    return {
      serverError: true,
    };
  } finally {
    thunkAPI.dispatch(hideAppLoader());
  }
});

export const validateBusinessSubscribers = createAsyncThunk(
  'businessWorkOrderSystem/validateBusinessSubscribers',
  async (data, thunkAPI) => {
    thunkAPI.dispatch(showAppLoader());
    try {
      const result = await ProviderManager.getProviderData('ValidateBusinessSubscribers', data);
      return result.Body;
    } catch (error) {
      return error;
    } finally {
      thunkAPI.dispatch(hideAppLoader());
    }
  },
);

export const submitClosingFU = createAsyncThunk('businessWorkOrderSystem/submitClosingFU', async (data, thunkAPI) => {
  thunkAPI.dispatch(showAppLoader());
  try {
    const result = await ProviderManager.getProviderData('closeBusinessWorkOrder', data);
    return result.Body;
  } catch (error) {
    thunkAPI.dispatch(hideAppLoader());
    return {
      serverError: true,
    };
  } finally {
    thunkAPI.dispatch(hideAppLoader());
  }
});

export const initialState = {
  loading: false,
  error: null,
  data: null,
  currentStep: '',
  workOrderTypes: [],
  loadingMoreRows: false,
  dashboardData: [],
  filterSearch: false,
  dashboardDataCurrentPage: 0,
  moreRows: false,
  workOrderForm: null,
  selectedWorkOrderType: '',
  generalMessage: null,
  workOrderNumber: '',
  selectedSubject: '',
  workOrderParams: {},
  expirationData: '', //  generalMessage param // to do
  stayInformedValue: StayInformedChoiceEnum.MAIL,
  stayInformedEmail: '',
  isReopenWorkOrder: false,
  WorkOrderCreation: {
    workOrderId: '',
    dueDate: '',
    userFullName: '',
  },
  files: [],
  deviceRepairSubscribersList: [
    {
      subscriber: '',
      deviceSerialNumber: '',
      securityCodeExist: false,
      alternatePhoneRequired: false,
      securityCode: '',
      clearContentApproved: false,
      causeList: [
        {
          selectedCauseType: '',
          selectedCauseSubType: '',
        },
      ],
      open: true,
    },
  ],
  selectedWorkOrderRow: null,
  currentPopUp: '',
  currentPopupData: null,
  showPopup: false,
};

const businessWorkOrderSystemSlice = createSlice({
  name: 'businessWorkOrderSystem',
  initialState,
  reducers: {
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setError: (state, action) => {
      state.error = action.payload;
    },
    setCurrentStep: (state, action) => {
      state.currentStep = action.payload;
      if (action.payload == BusinessWorkOrderSystemStep.ReopenWorkOrder) {
        state.isReopenWorkOrder = true;
      } else if (action.payload != BusinessWorkOrderSystemStep.WorkOrderConfirmation) {
        state.isReopenWorkOrder = false;
      }
    },
    setLoadingMoreRows: (state, action) => {
      state.loadingMoreRows = true;
    },
    setData: (state, action) => {
      state.data = action.payload;
    },
    resetState: (state) => {
      state.loading = false;
      state.error = null;
      state.data = null;
    },
    resetWorkOrderData: (state) => {
      state.workOrderParams = {};
      state.deviceRepairSubscribersList = initialState.deviceRepairSubscribersList;
      state.files = [];
      state.selectedWorkOrderType = '';
      state.selectedSubject = '';
      state.stayInformedValue = StayInformedChoiceEnum.MAIL;
      state.stayInformedEmail = '';
      state.isReopenWorkOrder = false;
      state.WorkOrderCreation = {workOrderId: '', dueDate: '', userFullName: ''};
      return state;
    },
    setGeneralMessage: (state, action) => {
      state.generalMessage = action.payload;
    },
    setSelectedWorkOrderType: (state, action) => {
      state.selectedWorkOrderType = action.payload;
    },
    setSelectedSubject: (state, action) => {
      state.selectedSubject = action.payload;
    },
    setSelectedFormType: (state, action) => {
      state.selectedFormType = action.payload;
    },
    saveToHistory: (state, action) => {
      return state;
    },
    setInputsList: (state, action) => {
      state.workOrderParams = {
        ...state.workOrderParams,
        [action.payload.paramcode]: {...state.workOrderParams[action.payload.paramcode], ...action.payload},
      };
    },

    setInputsListBulk: (state, action) => {
      const updates = action.payload;
      Object.keys(updates).forEach((paramCode) => {
        state.workOrderParams[paramCode] = {
          ...state.workOrderParams[paramCode],
          ...updates[paramCode],
        };
      });
    },
    setBottomBlockData: (state, action) => {
      state.bottomBlockData = {...state.bottomBlockData, ...action.payload};
    },
    setParamToDisplay: (state, action) => {
      var paramCode = action.payload.paramCode;
      state.workOrderParams[paramCode].display = action.payload.display;
    },
    setStayInformedChoice: (state, action) => {
      state.stayInformedValue = action.payload;
    },
    setStayInformedEmail: (state, action) => {
      state.stayInformedEmail = action.payload;
    },
    resetDisabledParams: (state) => {
      Object.values(state.workOrderParams || {}).forEach((param) => {
        if (!isNullOrEmpty(param.paramDependenCode) && state.workOrderParams[param.paramCode] && !isNullOrEmpty(param.error)) {
          state.workOrderParams[param.paramCode].disabled = true;
        } else {
          state.workOrderParams[param.paramCode].disabled = false;
        }
      });
      return state;
    },
    setFiles: (state, action) => {
      state.files = action.payload;
    },
    setDeviceRepairFile: (state, action) => {
      var existingDeviceRepairFile = state.files.find((file) => file.isDeviceRepair);
      if (existingDeviceRepairFile) {
        existingDeviceRepairFile.fileContentBase64 = action.payload.fileContentBase64;
      } else {
        state.files = [...state.files, action.payload];
      }
    },

    setDeviceRepairSubscribersList: (state, action) => {
      state.deviceRepairSubscribersList = action.payload;
    },

    setDeviceRepairSubscriber: (state, action) => {
      var index = action.payload.index;
      var data = action.payload.data;
      var updatedSubscribersList = state.deviceRepairSubscribersList.map((subscriber, idx) =>
        idx === index ? {...subscriber, ...data} : subscriber,
      );
      state.deviceRepairSubscribersList = updatedSubscribersList;
    },
    pushToHistory: (state, action) => {
      return state;
    },
    clearHistory: (state, action) => {
      return state;
    },
    setShowPopUp: (state, action) => {
      if (!action.payload) {
        state.currentPopUp = '';
        state.currentPopupData = null;
      }
      state.showPopup = action.payload;
      return state;
    },
    setCurrentPopUp: (state, action) => {
      state.showPopup = true;
      state.currentPopUp = action.payload.currentPopUp;
      state.currentPopupData = action.payload.currentPopupData;
      return state;
    },
    setSelectedWorkOrderRow: (state, action) => {
      state.selectedWorkOrderRow = action.payload;
    },
  },
  extraReducers: {
    [fetchExistingRequests.fulfilled]: (state, action) => {
      if (!action.payload?.isAxiosError && !action.payload.errorCode) {
        if (action.payload.workOrderList.length > 0) {
          // Format dates in the workOrderList
          const formattedWorkOrderList = action.payload.workOrderList.map((row) => ({
            ...row,
            fuOpenDateFormatted: formatDateString14digits(row.fuOpenDate),
            fuDueDateFormatted: formatDateString14digits(row.fuDueDate),
            fuCloseDateFormatted: row.fuCloseDate ? formatDateString14digits(row.fuCloseDate) : row.fuCloseDate,
          }));

          if (state.loadingMoreRows) {
            state.dashboardData = [...state.dashboardData, ...formattedWorkOrderList];
            state.loadingMoreRows = false;
          } else {
            state.dashboardData = formattedWorkOrderList;
          }

          state.moreRows = action.payload.moreRows;
          state.dashboardDataCurrentPage = action.payload.currentPage;
        } else {
          if (state.currentStep == '') {
            state.currentStep = BusinessWorkOrderSystemStep.WorkOrderTypeSelecting;
          } else {
            state.dashboardData = [];
          }
        }
      }
    },
    [getWorkOrderData.fulfilled]: (state, action) => {
      if (!action.payload?.isAxiosError && !action.payload.errorCode) {
        let newData = state.dashboardData.map((row) => {
          if (row.fuId === action.payload.fu_number) {
            return {
              ...row,
              fuStatusDescription: action.payload.fuStatusDescription,
              openedBy: action.payload.openedBy,
              fuDetails: action.payload.fuDetails,
              fuFiles: action.payload.fuFiles ? action.payload.fuFiles : [],
            };
          }
          return row;
        });
        state.dashboardData = newData;
        state.currentPopUp = BusinessWorkOrderSystemPopup.WorkOrderData;
        state.currentPopupData = newData.find((r) => r.fuId == action.payload.fu_number);
        state.showPopup = true;
      }
    },
    [getAllBusinessWorkOrderTypes.fulfilled]: (state, action) => {
      if (!action.payload?.isAxiosError && !action.payload.errorCode) {
        state.workOrderTypes = action.payload;
      } else {
        handleErrorPage(state);
      }
    },
    [getAllBusinessWorkOrderTypes.rejected]: (state, action) => {
      handleErrorPage(state);
      return state;
    },
    [getWorkOrderForm.fulfilled]: (state, action) => {
      if (!action.payload?.isAxiosError && !action.payload.errorCode) {
        state.workOrderParams = action.payload;
        var DD_Dependencies = [];

        //define which params display

        Object.values(state.workOrderParams || {})?.forEach((param) => {
          state.workOrderParams[param.paramCode].display = true;
          if (param.dropdownOptions) {
            var allDependencies = param.dropdownOptions.filter((option) => option.dependency != null);
            allDependencies.forEach((d) => {
              if (d.dependency && state.workOrderParams[d.dependency]) {
                DD_Dependencies.push(d.dependency);
              }
            });
          }
        });

        Object.values(state.workOrderParams || {})?.forEach((param) => {
          if (DD_Dependencies.includes(param.paramCode)) {
            state.workOrderParams[param.paramCode].display = false;
          }
          var default_Param = param.dropdownOptions?.find((option) => option.default_ind);
          if (default_Param && default_Param.dependency && state.workOrderParams[default_Param.dependency]) {
            state.workOrderParams[default_Param.dependency].display = true;
          }
        });

        //define which params disabled
        Object.values(state.workOrderParams || {}).forEach((param) => {
          if (!isNullOrEmpty(param.paramDependenCode) && state.workOrderParams[param.paramCode] && isNullOrEmpty(param.dropdownOptions)) {
            state.workOrderParams[param.paramCode].disabled = true;
          }
        });

        //state.currentStep = BusinessWorkOrderSystemStep.WorkOrderForm;
      }
    },
    [getWorkOrderForm.rejected]: (state, action) => {
      handleErrorPage(state);
      return state;
    },
    [validateSelectedAccount.fulfilled]: (state, action) => {
      var isDeviceRepair = isNullOrEmpty(action.payload.paramCode);
      var lastIndex = state.deviceRepairSubscribersList.length - 1;
      if (!action.payload.isAllowed) {
        var error = SubscriberErrorEnum[action.payload.description];
        if (error) {
          if (isDeviceRepair) {
            state.deviceRepairSubscribersList[lastIndex].errors = {
              ...state.deviceRepairSubscribersList[lastIndex].errors,
              subscriber: error,
            };
          } else {
            state.workOrderParams[action.payload.paramCode].error = error;
          }
        }
      }
      if (!isDeviceRepair) {
        state.workOrderParams[action.payload.paramCode].isLoading = false;
      }
      return state;
    },
    [getExtendedParamData.fulfilled]: (state, action) => {
      var result = action.payload.result;
      if (result.Header.ReturnCode == '0') {
        state.workOrderParams[action.payload.paramCode].disabled = false;
        state.workOrderParams[action.payload.paramCode].getExtendedData = true;
        state.workOrderParams[action.payload.paramCode].dropdownOptions = result.Body.dropdownOptions;
      } else {
        handleErrorPage(state);
      }
      state.workOrderParams[action.payload.paramCode].isLoading = false;
    },
    [getExtendedParamData.pending]: (state, action) => {
      state.workOrderParams[action.meta.arg.paramCode].isLoading = true;
      return state;
    },
    [getExtendedParamData.rejected]: (state, action) => {
      handleErrorPage(state);
    },
    [createBusinessWorkOrder.fulfilled]: (state, action) => {
      if (action.payload.isSuccess) {
        state.WorkOrderCreation = {
          workOrderId: action.payload.workOrderId,
          dueDate: action.payload.dueDate,
          userFullName: action.payload.userFullName,
        };
      }
    },
    [createBusinessWorkOrder.rejected]: (state, action) => {
      openErrorPopup(state);
      return state;
    },
    [validateBusinessSubscribers.fulfilled]: (state, action) => {
      if (!action.payload.isSuccess) {
        openErrorPopup(state);
        return state;
      }
    },
    [submitClosingFU.fulfilled]: (state, action) => {
      if (action.payload.isSuccess) {
        const currentFu = state.dashboardData.find((fu) => fu.fuId === state.currentPopupData.fuId);
        currentFu.fuStatusDescription = 'סגור';
        currentFu.fuCloseDate = action.payload.message;
        //update dashboardData
        state.dashboardData = state.dashboardData.map((fu) => (fu.fuId === state.currentPopupData.fuId ? currentFu : fu));
        state.currentPopupData = {
          icon: require('./Icons/success.svg'),
          title: `פניה מספר ${state.currentPopupData.fuId} נסגרה בהצלחה`,
          buttonText: 'סגור',
          buttonClick: 'setShowPopUp',
        };
        state.currentPopUp = BusinessWorkOrderSystemPopup.GeneralMessage;
      } else {
        state.currentPopupData = {
          icon: require('./Icons/error.svg'),
          title: 'מצטערים, משהו השתבש ולא ניתן לבצע את הפעולה שביקשת',
          buttonText: 'סגור',
          buttonClick: 'setShowPopUp',
        };
        state.currentPopUp = BusinessWorkOrderSystemPopup.GeneralMessage;
      }
    },

    [validateSelectedAccount.rejected]: (state, action) => {
      openErrorPopup(state);
      return state;
    },
    [validateSimCardNumber.rejected]: (state, action) => {
      openErrorPopup(state);
      return state;
    },
  },
});

export const SubscriberErrorEnum = {
  Unknown: 'מצטערים ארעה שגיאה בעת האימות',
  OrgIdNotFound: 'מזהה הארגון לא נמצא',
  AccountNotFound: 'החשבון לא נמצא',
  MemberOfDifferentOrg: 'המספר שייך לארגון אחר',
  ErrorOnValidation: 'מצטערים ארעה שגיאה בעת האימות',
  PhoneNumberNotFound: 'מספר הטלפון לא נמצא',
  MemberOfDifferentOrgNotAllowedToContactPerson: 'המנוי אינו שייך לאחד האירגונים שבאחריותך',
  NoEquipmentIsAttached: 'למנוי זה אין ציוד מחובר',
  cellcomNumber: `מספר זה שייך לרשת ${() => window.Config?.brand_Name_HE}`,
  SimCardNotValid: 'מספר הסים אינו תקין',
};

export const {
  setLoading,
  setLoadingMoreRows,
  setError,
  setData,
  setDeviceRepairFile,
  resetState,
  setCurrentStep,
  setGeneralMessage,
  setSelectedWorkOrderType,
  setFiles,
  setDeviceRepairSubscriber,
  setSelectedSubject,
  saveToHistory,
  pushToHistory,
  clearHistory,
  setSelectedFormType,
  setInputsList,
  setInputsListBulk,
  setBottomBlockData,
  setParamToDisplay,
  resetDisabledParams,
  setStayInformedChoice,
  setStayInformedEmail,
  setDeviceRepairSubscribersList,
  setShowPopUp,
  setCurrentPopUp,
  setSelectedWorkOrderRow,
  resetWorkOrderData,
} = businessWorkOrderSystemSlice.actions;

export default businessWorkOrderSystemSlice.reducer;
